import { apiClient } from './api-client';
import { getHeaders } from './utils';

/**
 * Fetches a care-hooks endpoint.
 *
 * `TData` is an unchecked claim confined to this boundary rather than validation — see
 * the note in `LyticsFetcher`. It defaults to `unknown`: both consumers want
 * `TriageSurveyFetchedRecord[] | undefined`, but that type lives inside each modal's
 * own subtree, so naming it here would make this service depend on a component. Each
 * hook supplies it instead.
 */
export const careGet = async <TData = unknown>(endpoint: string, token: string): Promise<TData> => {
  return await apiClient.get<TData>(import.meta.env.VITE_CARE_HOOKS_API_NAME, endpoint, {
    headers: getHeaders(token),
  });
};

/**
 * POSTs to a care-hooks endpoint.
 *
 * `TResponse` defaults to `unknown` because neither consumer reads the reply —
 * both `await carePost(...)` for its settlement and discard the value. `payload`
 * is `unknown` because it is serialised without being read here.
 */
export const carePost = async <TResponse = unknown>(
  token: string,
  endpoint: string,
  payload: unknown,
): Promise<TResponse> => {
  const result = await apiClient.post<TResponse>(
    import.meta.env.VITE_CARE_HOOKS_API_NAME,
    endpoint,
    {
      headers: getHeaders(token),
      body: payload,
    },
  );

  return result;
};
